import { useState } from "react";
import useEvent from "react-use-event-hook";

import { createRandomQaError } from "./error-boundary-qa.utils";

interface IUseErrorBoundaryQaPanelResult {
  pendingError: Error | null;
  handleGenerateErrorClick: () => void;
}

export const useErrorBoundaryQaPanel = (): IUseErrorBoundaryQaPanelResult => {
  const [pendingError, setPendingError] = useState<Error | null>(null);

  const handleGenerateErrorClick = useEvent(() => {
    setPendingError(createRandomQaError());
  });

  return {
    pendingError,
    handleGenerateErrorClick,
  };
};
